module.exports = __webpack_public_path__ + "img/jcyy.90677a51.png";